import { useContext, useState, useEffect } from "react";
import { JourneysContext } from "../../../context/journeys-context";
import { filterOnSearch } from "apps/journeys/utils/helpers";
import { PropTypes } from "base/react-libs";
import { SearchBox } from "@evertrue/et-components";
import { connect } from "@evertrue/et-flux";
import JourneysConstituentsActions from "./journeys-constituents-actions";
import SelectedContactsStore from "apps/contact/stores/selected-contacts-store";
import ContactsFixedTable from "apps/contact/components/contacts/contact-fixed-table";
import QueryBuilderModal from "apps/query-builder/components/query-builder-modal";
import useFetchContacts from "apps/search/hooks/use-fetch-contacts";
import TableToolbar from "components/tables/table-toolbar";

const mapStateToProps = () => ({
  selected: SelectedContactsStore.getSelectedContacts(),
});

const JourneysConstituentList = ({ selected = [] }) => {
  const { filters, filterCount, setContactFilters, tableSettings, updateTableSettings, setIsAllSelectedCheckbox } =
    useContext(JourneysContext);

  const [searchInput, setSearchInput] = useState();

  const { contactsData, loading, offset, LIMIT } = useFetchContacts(filters, tableSettings);
  const [tableContents, setTableContents] = useState(contactsData);

  // Update table contents when contactsData changes (i.e. when filters change)

  useEffect(() => {
    if (!searchInput) {
      setTableContents(contactsData);
    } else {
      const filteredData = { ...contactsData, items: filterOnSearch(contactsData.items, searchInput) };
      setTableContents(filteredData);
    }
  }, [contactsData, searchInput]);

  const handleRemove = (contacts) => {
    const filteredData = { ...tableContents };
    const ids = contacts.map((contact) => contact.id);
    filteredData.items = tableContents.items.filter((item) => !ids.includes(item.id));
    setTableContents(filteredData);
  };

  return (
    <div>
      <div className="journey-search-action-bar">
        <div className="search-filter-controller">
          <SearchBox
            className="journey-search-box"
            placeholder="Search for Constituent"
            onChange={(e) => {
              setSearchInput(e);
            }}
          />
          <QueryBuilderModal
            onApply={(change) => setContactFilters({ ...change }, true)}
            filterCount={filterCount}
            contactFilters={filters}
            setIsAllSelectedCheckbox={setIsAllSelectedCheckbox}
          />
        </div>
        <JourneysConstituentsActions
          selected={selected}
          assignedContacts={tableContents.items}
          handleRemove={handleRemove}
        />
      </div>

      <TableToolbar
        resultCount={tableContents.items.length || 0}
        page={tableSettings.page}
        offset={offset}
        limit={LIMIT}
        onPage={(page) => {
          updateTableSettings({ page });
          setIsAllSelectedCheckbox(false);
        }}
      />
      <ContactsFixedTable
        topPosition="310px"
        contacts={tableContents}
        loading={loading}
        onSort={(prop, order) => updateTableSettings({ sortProp: prop, sortReverse: order })}
        showCheckbox={true}
        numSelected={selected.length}
      />
    </div>
  );
};

JourneysConstituentList.propTypes = {
  selected: PropTypes.array,
};

export default connect(JourneysConstituentList, [SelectedContactsStore], mapStateToProps);
